<template>
  <div style="display: contents;">
    <ValidationObserver ref="bookingForm" slim>
      <b-form name="BookingPaxFrm" novalidate @submit.prevent="book()">
        <b-row>
          <b-container>
            <b-row>
              <template v-if="showWebDescriptions">
                <b-col sm="12" v-for="(desc, index) in result.web_descriptions" :key="'desc' + index" class="py-1 mt-2">
                  <h6 class="package-title">{{ desc.label }}</h6>
                  <div v-html="desc.text"></div>
                  <hr>
                </b-col>
              </template>
              <b-col sm="12">
                <b-table-simple stacked="sm" striped caption-top class="table table-sm">
                  <caption class="pl-2 pl-sm-0 pb-0">
                    <h6 class="package-title">Detalii Pasageri</h6>
                  </caption>
                  <b-thead class="t-head hh-t-head">
                    <b-tr>
                      <b-td></b-td>
                      <b-td>Nume*</b-td>
                      <b-td>Prenume*</b-td>
                      <b-td>Varsta</b-td>
                      <b-td>Data nasterii*</b-td>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <template v-for="(p, pIndex) in pax">
                      <PaxForm v-model="pax[pIndex]" :id="'pax' + pIndex" :key="'pax' + pIndex"
                        :travelDate="travelDate" />
                    </template>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <hr class="mb-0">
                <p style="margin-bottom:0;"><em>*Campurile marcate cu asterisc sunt obligatorii!</em></p>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col sm="8">
                <div class="printArea">
                  <h6>Note Agent*</h6>
                  <textarea v-model="notes" class="form-control noPrint">...</textarea>
                  <div class="printArea" style="display: none">
                    <p>{{ notes }}</p>
                  </div>
                </div>
              </b-col>
              <b-col sm="4">
                <span class="printArea">
                  <h6>Numar de telefon*</h6>
                  <span class="printArea" style="display: none">{{ telephone }}</span>
                </span>
                <ValidationProvider name="numar de telefon" :rules="{ required: true }" v-slot="vContext">
                  <b-form-group>
                    <b-form-input type="text" :name="'telefon'" placeholder="nr de telefon"
                      class="form-control form-control-sm" v-model="telephone" size="sm"
                      :state="getValidationState(vContext)" aria-describedby="telefon"></b-form-input>
                    <b-form-invalid-feedback id="telefon">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <small>*Acest numar de telefon va fi utilizat exclusiv pentru contactarea turistilor in caz de
                  urgenta.</small>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="7">
                <b-card no-body class="px-2 py-1">
                  <ValidationProvider name="terms" rules="is:acceptat" vid="terms" v-slot="vContext" slim>
                    <b-form-group>
                      <b-form-checkbox id="conditions" name="conditions" v-model="termsAccepted"
                        :state="getValidationState(vContext)" aria-describedby="conditions-live-feedback"
                        value="acceptat" unchecked-value="neacceptat">
                        Am citit si sunt de acord cu <span class="text-info" @click="openTermsAndConditions">Termenii si
                          conditiile</span> de comercializare a produselor.
                      </b-form-checkbox>
                      <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)">nu
                        ati acceptat termenii si conditiile</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-card>
              </b-col>
              <b-col md="5" class="printArea">
                <b-card bg-variant="light" style="font-size:16px;" class="text-center">
                  <span>Pret total: <span class="text-danger font-weight-bold">{{ result.gross }} {{ result.currency }}
                    </span> <small>(taxe incluse)</small></span>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card bg-variant="light" no-body>
                  <b-card-body class="p-1 p-md-3">
                    <div class="d-md-flex justify-content-md-between">
                      <b-button variant="warning" size="sm" @click="close" class="mb-2 mb-md-0"><b-icon
                          icon="chevron-left" />Inapoi</b-button>
                      <b-button variant="warning" size="sm" type="submit">Rezerva acum</b-button>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="showOverlay" title="Status" size="xl" hide-header hide-footer no-close-on-esc
      no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner label="Loading...'" variant="primary"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>
    <b-modal v-model="showErrorOverlay" title="Error" size="xl" hide-header hide-footer no-close-on-esc
      no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class=" font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3" />
            A aparut o problema
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted"> - Din pacate rezervarea nu a putut fi inregistrata deoarece a aparut o
            problema.</b-card-text>
          <b-card-text class="lead text-muted"> - In general acest lucru se intampla atunci cand pretul sau
            disponibilitatea produsului s-au modificat de la momentul in care ati efectuat cautarea.</b-card-text>
          <b-card-text class="lead text-muted"> Mesajul de eroare este: <b class="text-info">{{ errorMessage
              }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="close">Inchide</b-button>
      </b-card>
    </b-modal>
    <b-modal v-model="termsAndConditions" title="Termeni si Conditii" size="xl" hide-header hide-footer no-close-on-esc
      no-close-on-backdrop>
      <b-card>
        <TermsAndConditions />
        <hr>
        <b-button variant="warning" class="float-right" @click="closeTermsAndConditions">Accepta</b-button>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

import model from '../services/model'
import toast from 'b2b-common/mixins/toast'
import auth from 'b2b-common/mixins/auth'
import validation from 'b2b-common/mixins/validation'
import PaxForm from '@/app/private/shared/components/pax_form'
import TermsAndConditions from '../../shared/components/terms_and_conditions'

import { book } from 'b2b-common/services/api/other'

const invalidFormMessage = 'Formular invalid'

export default {
  name: 'BookForm',
  mixins: [toast, auth, validation],
  props: ['params', 'result', 'showWebDescriptions'],
  components: { PaxForm, TermsAndConditions },
  computed: {
    duration () {
      return moment(this.params.return_date, 'DD-MM-YYYY').startOf('day').diff(moment(this.params.date, 'DD-MM-YYYY').startOf('day'), 'days')
    },
    travelDate () { return moment(this.params.date, 'DD-MM-YYYY') }
  },
  data () {
    const pax = []
    for (let i = 0; i < this.params.adults; i++) {
      pax.push({
        title: 'Mr',
        fname: '',
        lname: '',
        age: 'adult',
        bdate: null
      })
    }
    this.params.child_ages.forEach(age => {
      pax.push({
        title: (age < 2) ? 'Inf' : 'Chd',
        fname: '',
        lname: '',
        age: age,
        bdate: null
      })
    })

    return {
      model,
      notes: '',
      telephone: '',
      pax,
      termsAccepted: 'unaccepted',
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: 'eroare necunoscuta',
      termsAndConditions: false
    }
  },
  methods: {
    close () {
      this.$emit('closeModal')
    },
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    },
    async book () {
      try {
        const success = await this.$refs.bookingForm.validate()
        if (!success) {
          this.addToast({ title: invalidFormMessage, message: ' Va rugam sa completati toate campurile!', variant: 'danger' })
          throw new Error(invalidFormMessage)
        }
        this.showOverlay = true
        this.overlayMessage = 'Va rugam sa asteptati, verificam din nou pretul si disponibilitatea produsului selectat...'

        const pax = this.pax.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate,
          tel: this.telephone ? this.telephone : ''
        }))

        // now ok to create booking
        const bookParams = {
          result: this.result.index,
          notes: this.notes,
          tel: this.telephone,
          pax: pax
        }

        const res = await book(bookParams)
        model.results = []
        this.$emit('book', res[0])
      } catch (err) {
        if (err.message !== invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
        throw err
      } finally { this.showOverlay = false }
    }
  }
}
</script>
